var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnotationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 0.751953C5.97656 0.751953 1.5 4.10742 1.5 8.25195C1.5 11.1816 3.74609 13.7129 7.01172 14.9473L6.11008 17.3484C5.75288 18.2997 6.8775 19.1156 7.67094 18.4808L11.1016 15.7363C11.2344 15.7402 11.3633 15.752 11.5 15.752C17.0234 15.752 21.5 12.3965 21.5 8.25195C21.5 4.10742 17.0234 0.751953 11.5 0.751953ZM6.5 9.91992C5.58203 9.91992 4.83203 9.17383 4.83203 8.25195C4.83203 7.33008 5.57812 6.58398 6.5 6.58398C7.41797 6.58398 8.16797 7.33008 8.16797 8.25195C8.16797 9.17383 7.41797 9.91992 6.5 9.91992ZM11.5 9.91992C10.582 9.91992 9.83203 9.17383 9.83203 8.25195C9.83203 7.33008 10.5781 6.58398 11.5 6.58398C12.418 6.58398 13.168 7.33008 13.168 8.25195C13.168 9.17383 12.418 9.91992 11.5 9.91992ZM16.5 9.91992C15.582 9.91992 14.832 9.17383 14.832 8.25195C14.832 7.33008 15.5781 6.58398 16.5 6.58398C17.418 6.58398 18.168 7.33008 18.168 8.25195C18.168 9.17383 17.418 9.91992 16.5 9.91992Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnotationIcon);
export default __webpack_public_path__ + "static/media/annotationIcon.8693f0d0c89621edf7155472eaca7c6a.svg";
export { ForwardRef as ReactComponent };